import styled from 'styled-components'

export const CatalogItemDetailsThumbnailImageStyled = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  mix-blend-mode: multiply;
  pointer-events: none;
`
